import { Component, OnInit } from '@angular/core';
import { localStorageKeys } from '../../../Models/configurations';
import { SecureStorageService } from './../../../Services/secure-storage.service';

@Component({
  selector: 'app-dealer-address',
  templateUrl: './dealer-address.component.html',
  //styleUrls: ['./dealer-address.component.css']
})
export class DealerAddressComponent implements OnInit {

  dealerDetail: any;

  constructor(
    private readonly secureStorageService: SecureStorageService,
  ) { }

  ngOnInit(): void {
    let data = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    this.dealerDetail = data.dealerDetail;
  }
}
